import type { IUserSubscriptionPlans, UserSubscriptionPlanEnum } from "./types";

export type IIntLimitsAccessGroup = {
	value: number;
	accessGroupMap: {
		[key in IUserSubscriptionPlans]?: boolean;
	};
}[];
type validateIntAcordAccessLimitReturn =
	| {
			isAvailable: false;
			lastAvailableValue: number;
	  }
	| {
			isAvailable: true;
	  };

export function validateIntAcordAccessLimit(
	value: number,
	userGroup: UserSubscriptionPlanEnum,
	limits: IIntLimitsAccessGroup
): validateIntAcordAccessLimitReturn {
	const lastLimit = limits[limits.length - 1];

	for (let i = 0; i < limits.length; i++) {
		const limit = limits[i];
		if (value > limit.value) continue;
		if (userGroup in limit.accessGroupMap) {
			return {
				isAvailable: true
			} as const;
		}
		return {
			isAvailable: false,
			lastAvailableValue: backtrackLastAvalible(i, userGroup, limits).value
		} as const;
	}

	if (userGroup in lastLimit.accessGroupMap) {
		return { isAvailable: true } as const;
	}

	return {
		isAvailable: false,
		lastAvailableValue: backtrackLastAvalible(limits.length - 1, userGroup, limits).value
	} as const;
}
export const backtrackLastAvalible = (
	startIndex: number,
	userGroup: UserSubscriptionPlanEnum,
	limits: IIntLimitsAccessGroup
) => {
	for (let j = startIndex - 1; j >= 0; j--) {
		const backtrackLimit = limits[j];
		if (userGroup in backtrackLimit.accessGroupMap) return backtrackLimit;
	}
	return limits[0];
};
